// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ot-0";
export var animationContainer = "_ot-1";
export var itemPrice = "_ot-a";
export var itemizedContent = "_ot-9";
export var itemizedHeader = "_ot-7";
export var itemizedRow = "_ot-8";
export var itemizedSection = "_ot-6";
export var modalContent = "_ot-2";
export var orderName = "_ot-3";
export var refundOption = "_ot-4";
export var refundOptionsContainer = "_ot-5";
export var shippingLabel = "_ot-b";
export var totalRow = "_ot-c";